/**
 * LINE プラン残量表示。
 * 仕様書: docs/01_spec/spec_line_bot.md A-10.5（Phase 22g）
 */
import { AlertTriangle, Send } from 'lucide-react';

import { useLineMessageQuota } from '@/hooks/useLineNews';

export function PlanQuotaBadge() {
  const { data, isLoading, isError } = useLineMessageQuota();

  if (isLoading) {
    return (
      <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-[var(--bg-elevated)] border border-[var(--border)] text-[10px] text-[var(--text-muted)]">
        <Send className="size-3" /> 残量読み込み中…
      </span>
    );
  }
  if (isError || !data?.ok) {
    return (
      <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-[var(--accent-amber-subtle)] border border-[var(--accent-amber)] text-[10px] text-[var(--accent-amber)]">
        <AlertTriangle className="size-3" /> 残量取得失敗
      </span>
    );
  }

  if (data.type === 'none') {
    return (
      <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-[var(--accent-green-subtle)] border border-[var(--accent-green)] text-[10px] text-[var(--accent-green)]">
        <Send className="size-3" /> 配信: {data.used.toLocaleString()} / 無制限
      </span>
    );
  }

  const limit = data.limit ?? 0;
  const used = data.used;
  const ratio = limit > 0 ? used / limit : 0;
  const danger = ratio >= 0.9;
  const warn = ratio >= 0.7;

  const colorClass = danger
    ? 'bg-[var(--accent-red-subtle)] border-[var(--accent-red)] text-[var(--accent-red)]'
    : warn
      ? 'bg-[var(--accent-amber-subtle)] border-[var(--accent-amber)] text-[var(--accent-amber)]'
      : 'bg-[var(--accent-green-subtle)] border-[var(--accent-green)] text-[var(--accent-green)]';

  return (
    <span
      className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full border text-[10px] ${colorClass}`}
      title={`残り ${(data.remaining ?? 0).toLocaleString()} 通`}
    >
      <Send className="size-3" />
      配信: {used.toLocaleString()} / {limit.toLocaleString()}
    </span>
  );
}
